import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { currencyFormatter } from "../../pickup/pickup-detail/pickup-detail-table/column-formatters";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getFundtypeAll } from "../../../../MasterData/_redux/fund_type/fundtypeCrud";
import { getProgramAll } from "../../../../MasterData/_redux/program/programCrud";
import { getBankAccountAll } from "../../../../MasterData/_redux/bank-account/bankAccountCrud";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import SelectDonaturModal from "./SelectDonaturModal";
import { CardFooter } from "../../../../../../_metronic/_partials/controls";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { BlockOrg } from "../../../../../RoleChecker";

export default function ImportMutationBankTable({
  dataTable,
  selectedDonatur,
  setCurrentIndex,
  saveData,
  btnRef,
  openDonaturModal,
  setOpenDonaturModal,
}) {
  // const [openDonaturModal, setOpenDonaturModal] = useState(false);
  //  const [currentIndex, setCurrentIndex] = useState();

  const [options, setOptions] = useState({
    fund_type: [],
    program: [],
  });

  useEffect(() => {
    getOptions();
  }, []);

  const getOptions = () => {
    getFundtypeAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        fund_type: res.data.data,
      }))
    );
    getProgramAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        program: res.data.data,
      }))
    );
  };

  return (
    <>
      <SelectDonaturModal
        show={openDonaturModal}
        onHide={() => {
          setOpenDonaturModal(false);
          setCurrentIndex(null);
        }}
        selectedDonatur={selectedDonatur}
      />
      <Formik
        enableReinitialize={true}
        initialValues={{}}
        onSubmit={(values) => saveData(values)}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  <th>Pesan Bank</th>
                  <th className="text-right">Nominal</th>
                  <th>Jenis Dana</th>
                  <th>Program</th>
                  <th>Donatur</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {dataTable.map((item, index) => (
                  <tr key={item.uuid}>
                    <td>{index + 1}</td>
                    <td>{item.trx_date}</td>
                    <td>{item.message}</td>
                    <td className="text-right">
                      {currencyFormatter(item.amount)}
                    </td>
                    <td>
                      {!item[`fund_type_${index}`] ? (
                        <Autocomplete
                          name={`fund_type_${index}`}
                          options={options.fund_type}
                          getOptionLabel={(option) => option.name}
                          defaultValue={options.fund_type.find(
                            (option) =>
                              option.code === item[`fund_type_${index}`]
                          )}
                          disabled={
                            (item.donation_payment && true) ||
                            (item.reconcile_uuid && true)
                          }
                          onChange={(e, value) => {
                            value
                              ? setFieldValue(`fund_type_${index}`, value.code)
                              : setFieldValue(`fund_type_${index}`, null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Pilih Jenis Dana"
                              variant="outlined"
                              disableClearable
                              size="small"
                            />
                          )}
                        />
                      ) : (
                        <div>
                          {
                            (
                              options.fund_type.find(
                                (option) =>
                                  option.code === item[`fund_type_${index}`]
                              ) ?? {}
                            ).name
                          }
                        </div>
                      )}
                    </td>
                    <td>
                      {!item[`program_${index}`] ? (
                        <Autocomplete
                          name={`program_${index}`}
                          options={options.program.filter(
                            (item) =>
                              item.fund_type_code ===
                              values[`fund_type_${index}`]
                          )}
                          getOptionLabel={(option) => option.name}
                          defaultValue={options.program.find(
                            (option) => option.uuid === item[`program_${index}`]
                          )}
                          disabled={
                            (item.donation_payment && true) ||
                            (item.reconcile_uuid && true)
                          }
                          onChange={(e, value) => {
                            value
                              ? setFieldValue(`program_${index}`, value.uuid)
                              : setFieldValue(`program_${index}`, null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Pilih Jenis Program"
                              variant="outlined"
                              disableClearable
                              size="small"
                            />
                          )}
                        />
                      ) : (
                        <div>
                          {
                            (
                              options.program.find(
                                (option) =>
                                  option.uuid === item[`program_${index}`]
                              ) ?? {}
                            ).name
                          }
                        </div>
                      )}
                    </td>
                    <td>{item.donor_uuid ? item.donor_name : "-"}</td>
                    <td>
                      {item.reconcile_uuid
                        ? "Digunakan Settlement"
                        : item.donation_payment
                        ? "Digunakan Donasi"
                        : "-"}
                    </td>
                    <td>
                      {!item.donation_payment && !item.reconcile_uuid ? (
                        <OverlayTrigger
                          overlay={
                            <Tooltip id="products-edit-tooltip">
                              Pilih Donatur
                            </Tooltip>
                          }
                        >
                          <a
                            className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                            onClick={() => {
                              setOpenDonaturModal(true);
                              setCurrentIndex(index);
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-success">
                              <PersonAddIcon />
                            </span>
                          </a>
                        </OverlayTrigger>
                      ) : (
                        <OverlayTrigger
                          overlay={
                            <Tooltip id="products-edit-tooltip">Detail</Tooltip>
                          }
                        >
                          {item.reconcile_uuid ? (
                            <Link
                              to={`/settlement/settlement/${item.reconcile_uuid}/edit`}
                            >
                              <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                  <VisibilityIcon />
                                </span>
                              </a>
                            </Link>
                          ) : (
                            <Link to={`/donasi/${item.donation_uuid}/detail`}>
                              <a className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                  <VisibilityIcon />
                                </span>
                              </a>
                            </Link>
                          )}
                        </OverlayTrigger>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <CardFooter>
              {BlockOrg() && (
                <>
                  <button
                    className="btn btn-primary float-right"
                    onClick={handleSubmit}
                  >
                    Simpan
                  </button>
                </>
              )}
            </CardFooter>
          </>
        )}
      </Formik>
    </>
  );
}
